.box {
  background-color: var(--tds-grey-900);
  box-sizing: border-box;
  border-radius: 2px;
}
